import { render } from "./PosItemStock.vue?vue&type=template&id=2a9986d8"
import script from "./PosItemStock.vue?vue&type=script&lang=js"
export * from "./PosItemStock.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__